import { fetch, urlResolve } from '../../../../utils/fetch';

const getWholePath = (path) => {
  const prefix = '';
  return prefix + path;
};

/**
 * @desc undefined
 */
export function request(params, options = {}) {
  const fetchOption = Object.assign(
    {
      url: getWholePath('/useCase/front/useCaseInfo'),
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
      params: params,
    },
    options,
  );
  return fetch(fetchOption);
}
